import { api, LightningElement } from "lwc";
import { logger } from "@devforce/trailhead-client-logger";

type TitleMode = "anchor" | "button" | "text";

export default class extends LightningElement {
  @api complete: boolean = false;
  @api path: string | null = null;
  @api subtitle: string | null = null;
  @api title: string = "";

  private _titleMode: TitleMode = "anchor";

  @api
  get titleMode(): TitleMode {
    // Backwards compatability
    if (this._titleMode === "anchor" && !this.path) {
      if (process.env.NODE_ENV === "development") {
        logger.warn(
          `title-mode was set to "anchor" but is missing "path" attribute, falling back to "button"`
        );
      }
      return "button";
    }
    return this._titleMode;
  }

  set titleMode(value) {
    this._titleMode = value;
  }

  private onButtonClick() {
    this.dispatchEvent(new CustomEvent("navigate"));
  }

  private onItemClick(e: MouseEvent) {
    // This code allows the entire component to be clicked,
    // but we don't want to override the default behavior of anchors/buttons
    switch (this.titleMode) {
      case "anchor": {
        if (e.target && (e.target as HTMLElement).tagName === "A") break;
        window.location.href = this.path!;
        break;
      }
      case "button": {
        if (e.target && (e.target as HTMLElement).tagName === "BUTTON") break;
        this.dispatchEvent(new CustomEvent("navigate"));
        break;
      }
      default:
        break;
    }
  }

  private get titleIsAnchor() {
    return this.titleMode === "anchor";
  }

  private get titleIsButton() {
    return this.titleMode === "button";
  }

  private get titleIsText() {
    return this.titleMode === "text";
  }
}
